import { render, staticRenderFns } from "./tit-primary.vue?vue&type=template&id=2da17d1d&scoped=true&"
import script from "./tit-primary.vue?vue&type=script&lang=js&"
export * from "./tit-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da17d1d",
  null
  
)

export default component.exports